import { gql } from "@apollo/client";

/**
 * Request timings for /admin/performance.
 *
 * Rows are kinds of request, not requests — every number is an accumulator over
 * `requests`. See PerfLog on the server for why one row cannot be one request.
 */
export const GET_PERF_LOGS = gql`
  query GetPerfLogs($limit: Int, $offset: Int, $sort: String, $kind: String, $search: String) {
    perfLogs(limit: $limit, offset: $offset, sort: $sort, kind: $kind, search: $search) {
      total
      stats {
        trackedLabels
        totalRequests
        totalMs
        totalDbMs
        avgMs
        slowRequests
        verySlowRequests
        failedRequests
        trackedSince
        lastSeenAt
        slowMs
        verySlowMs
        retentionDays
      }
      logs {
        id
        label
        kind
        requests
        totalMs
        avgMs
        maxMs
        avgDbMs
        appMs
        avgQueries
        maxQueries
        slowCount
        verySlowCount
        errorCount
        slowShare
        worstAt
        worstContext
        firstSeenAt
        lastSeenAt
        copiedAt
      }
    }
  }
`;

/**
 * The paste-ready handoff as a pure read — nothing is stamped as handed over.
 * The button on the page uses COPY_PERF_REPORT, which records that it went.
 */
export const GET_PERF_REPORT = gql`
  query GetPerfReport($id: ID, $limit: Int, $sort: String, $kind: String, $search: String) {
    perfReport(id: $id, limit: $limit, sort: $sort, kind: $kind, search: $search)
  }
`;
